var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import { Button } from "../../../../../../../../Components/UI";
import { Translate } from "../../../../../../../../../I18N";
import * as extractorsAPI from "../../../../../../../../api/paragraphExtractor/extractors";
import { useRevalidator } from 'react-router';
import { useSetAtom } from 'jotai';
import { notificationAtom } from "../../../../../../../../atoms";
import { useCreateExtractorContext } from "../../CreateExtractorContext";

const Footer = () => {
  const revalidator = useRevalidator();
  const setNotifications = useSetAtom(notificationAtom);
  const {
    sourceTemplateId,
    setStep,
    targetTemplateId,
    setShowModal,
    paragraphPropertyId,
    paragraphNumberPropertyId,
    relationshipId
  } = useCreateExtractorContext();

  // TODO: should be moved to context?
  const handleSubmit = async () => {
    try {
      const values = {
        sourceTemplateId,
        targetTemplateId,
        paragraphPropertyId,
        paragraphNumberPropertyId,
        relationshipId
      };
      await extractorsAPI.save(values);
      setShowModal(false);
      await revalidator.revalidate();
      setNotifications({
        type: 'success',
        text: /*#__PURE__*/_jsx(Translate, {}, void 0, "Paragraph Extractor added")
      });
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('Error saving extractor:', e);
    }
  };

  return (/*#__PURE__*/
    React.createElement(React.Fragment, null, /*#__PURE__*/
    _jsx(Button, { styling: "light", onClick: () => setStep(2), className: "grow" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Cancel")
    ), /*#__PURE__*/
    _jsx(Button, {
      className: "grow disabled:opacity-50",
      color: "success",
      onClick: async () => handleSubmit(),
      disabled: !sourceTemplateId }, void 0, /*#__PURE__*/

    _jsx("span", { className: "flex items-center justify-center gap-2 flex-nowrap" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Create")
    )
    )
    ));

};

export { Footer };